import { render, staticRenderFns } from "./SingleShelter.vue?vue&type=template&id=eeb1cf40&"
import script from "./SingleShelter.vue?vue&type=script&lang=js&"
export * from "./SingleShelter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports